import type { RefPartner } from "@/models/refPartner";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export async function getRefPartners(
  slug?: string | null,
): Promise<APIResponse<RefPartner> | { data: null }> {
  try {
    const resp = await callApi<RefPartner>(
      slug
        ? `${API_BASE}/ref_partners/by-slug/${slug}`
        : `${API_BASE}/ref_partners`,
    );
    return resp;
  } catch {
    // swallow refferal 404's
    return {
      data: null,
    };
  }
}
